export default __webpack_public_path__ + "static/media/CT_Art2.013c8b04.png";